import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import * as i1 from '@angular/platform-browser';
import { switchMap, NEVER } from 'rxjs';

class CitadelBaseNumberPipe {
    currencySymbolToCode(symbol) {
        if (symbol.length > 1) {
            return symbol;
        }
        else {
            switch (symbol) { // TODO:Change this to read the values from lkpSharedCurrency
                case '$': return 'USD';
                case '€': return 'EUR';
                case '£': return 'GBP';
                case 'R': return 'ZAR';
            }
        }
    }
    transformValue(value, format, decimals, currency, invalidIsZero) {
        if (value === null || value === undefined) {
            return value;
        }
        const finalValue = (typeof value === 'string') ? parseFloat(value) : value;
        if (isNaN(finalValue)) {
            return invalidIsZero ? this.transformValue(0, format, decimals, currency, invalidIsZero) : value.toString();
        }
        format = format || 'number';
        decimals = decimals; //  || (format === 'percent' ? 1 : 2);
        const isZAR = format === 'amount' && (currency === 'ZAR' || currency === 'R');
        const numberStyle = isZAR ? 'decimal' : (format === 'amount' ? 'currency' : format);
        const numberOptions = {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals,
            useGrouping: true,
            style: numberStyle === 'number' ? 'decimal' : numberStyle
        };
        if (format === 'amount') {
            numberOptions.currency = this.currencySymbolToCode(currency);
        }
        let result = finalValue.toLocaleString('en-ZA', numberOptions);
        if (isZAR) {
            result = /*currency + */ 'R\xa0' + result;
        }
        return result;
    }
}

class CitadelNumberPipe extends CitadelBaseNumberPipe {
    transform(value, decimals = 2, invalidIsZero = false) {
        return this.transformValue(value, 'number', decimals, undefined, invalidIsZero);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelNumberPipe, deps: null, target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelNumberPipe, name: "citadelNumber" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelNumberPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'citadelNumber'
                }]
        }] });

class CitadelPercentPipe extends CitadelBaseNumberPipe {
    transform(value, decimals = 1, invalidIsZero = true) {
        return this.transformValue(value, 'percent', decimals, undefined, invalidIsZero);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelPercentPipe, deps: null, target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelPercentPipe, name: "percent" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelPercentPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'percent'
                }]
        }] });

class CitadelDateTimePipe {
    pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }
    formatDate(d) {
        const year = this.pad(d.getFullYear(), 4);
        const month = this.pad(d.getMonth() + 1, 2);
        const day = this.pad(d.getDate(), 2);
        return `${year}-${month}-${day}`;
    }
    formatTime(d, shortTime = false) {
        const hour = this.pad(d.getHours(), 2);
        const minute = this.pad(d.getMinutes(), 2);
        const second = this.pad(d.getSeconds(), 2);
        if (shortTime) {
            return `${hour}:${minute}`;
        }
        else {
            return `${hour}:${minute}:${second}`;
        }
    }
    transform(value, shortTime = false) {
        return this.transformDate(value, true, true, shortTime);
    }
    transformDate(value, addDate, addTime, shortTime = false) {
        let d = null;
        if (typeof value === 'string') {
            d = new Date(value);
            if (isNaN(d.getTime())) {
                return value;
            }
        }
        else if (!value) {
            return '';
        }
        else {
            d = value;
        }
        if (addDate && addTime) {
            return this.formatDate(d) + '\xa0' + this.formatTime(d, shortTime);
        }
        else if (addTime) {
            return this.formatTime(d, shortTime);
        }
        else {
            return this.formatDate(d);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDateTimePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelDateTimePipe, name: "citadelDateTime" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDateTimePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'citadelDateTime'
                }]
        }] });

class CitadelDatePipe extends CitadelDateTimePipe {
    transform(value) {
        return super.transformDate(value, true, false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDatePipe, deps: null, target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelDatePipe, name: "citadelDate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'citadelDate'
                }]
        }] });

class CitadelAmountPipe extends CitadelBaseNumberPipe {
    transform(value, currencyCode = 'ZAR', decimals = 0, invalidIsZero = false) {
        return this.transformValue(value, 'amount', decimals, currencyCode, invalidIsZero);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelAmountPipe, deps: null, target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelAmountPipe, name: "amount" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelAmountPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'amount'
                }]
        }] });

class CitadelTimePipe extends CitadelDateTimePipe {
    transform(value, shortTime = false) {
        return super.transformDate(value, false, true, shortTime);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelTimePipe, deps: null, target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelTimePipe, name: "citadelTime" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelTimePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'citadelTime'
                }]
        }] });

// import { Http, Headers, Response } from '@angular/http';
class CitadelCurrencyPipe {
    transform(value, ratio) {
        let retValue = value;
        if (ratio !== 0) {
            retValue = (value / ratio);
        }
        return retValue;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelCurrencyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelCurrencyPipe, name: "citadelCurrency" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelCurrencyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'citadelCurrency'
                }]
        }] });

class CitadelLogPipe {
    transform(value) {
        console.group('Logged from pipe');
        console.log(value);
        console.groupEnd();
        return;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLogPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelLogPipe, name: "log" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLogPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'log' }]
        }] });

class CitadelCurrencyAmountPipe {
    transform(value, decimals = 2) {
        let retValue = value;
        if (value === null) {
            retValue = '';
        }
        else {
            if (value.currency !== undefined && value.currency !== null && value.currency.currencySymbol !== undefined && value.amount !== undefined) {
                const citadelNumberPipe = new CitadelNumberPipe();
                retValue = value.currency.currencySymbol + ' ' + citadelNumberPipe.transform(value.amount, decimals);
            }
        }
        return retValue;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelCurrencyAmountPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelCurrencyAmountPipe, name: "citadelCurrencyAmount" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelCurrencyAmountPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'citadelCurrencyAmount'
                }]
        }] });

class CitadelSanitizerPipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelSanitizerPipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelSanitizerPipe, name: "citadelSanitizer" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelSanitizerPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'citadelSanitizer'
                }]
        }], ctorParameters: () => [{ type: i1.DomSanitizer }] });

function pausedBy(pauser) {
    if (!!pauser) {
        return source$ => pauser.pipe(switchMap(paused => paused ? NEVER : source$));
    }
    else {
        return source$ => source$;
    }
}

class CitadelPipesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelPipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelPipesModule, declarations: [CitadelAmountPipe,
            CitadelCurrencyPipe,
            CitadelDatePipe,
            CitadelDateTimePipe,
            CitadelNumberPipe,
            CitadelPercentPipe,
            CitadelTimePipe,
            CitadelLogPipe,
            CitadelCurrencyAmountPipe,
            CitadelSanitizerPipe], exports: [CitadelAmountPipe,
            CitadelCurrencyPipe,
            CitadelDatePipe,
            CitadelDateTimePipe,
            CitadelNumberPipe,
            CitadelPercentPipe,
            CitadelTimePipe,
            CitadelLogPipe,
            CitadelCurrencyAmountPipe,
            CitadelSanitizerPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelPipesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelPipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CitadelAmountPipe,
                        CitadelCurrencyPipe,
                        CitadelDatePipe,
                        CitadelDateTimePipe,
                        CitadelNumberPipe,
                        CitadelPercentPipe,
                        CitadelTimePipe,
                        CitadelLogPipe,
                        CitadelCurrencyAmountPipe,
                        CitadelSanitizerPipe,
                    ],
                    imports: [],
                    exports: [
                        CitadelAmountPipe,
                        CitadelCurrencyPipe,
                        CitadelDatePipe,
                        CitadelDateTimePipe,
                        CitadelNumberPipe,
                        CitadelPercentPipe,
                        CitadelTimePipe,
                        CitadelLogPipe,
                        CitadelCurrencyAmountPipe,
                        CitadelSanitizerPipe,
                    ]
                }]
        }] });

/*
 * Public API Surface of citadel-pipes
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CitadelAmountPipe, CitadelCurrencyAmountPipe, CitadelCurrencyPipe, CitadelDatePipe, CitadelDateTimePipe, CitadelLogPipe, CitadelNumberPipe, CitadelPercentPipe, CitadelPipesModule, CitadelSanitizerPipe, CitadelTimePipe, pausedBy };
